import React from 'react';
import i18n from '@i18n';
import SystemNg from './SystemNg';
import './SystemsListNg.less';

function SystemListNg({ systems, groups }) {
    if (!systems || !groups) {
        return null;
    }

    return (
        <div className="system-list">
            <div className="row system-type">{i18n('jsp.detailTiketu.rozpisy')}</div>
            <div className="row column-titles">
                <div>{i18n('jsp.detailTiketu.kombinacia')}</div>
                <div>{i18n('jsp.detailTiketu.vkladNaRozpis')}</div>
            </div>
            {systems.map((system, i) => (
                <SystemNg
                    key={i}
                    systemsCount={groups}
                    combination={system.get('combination')}
                    ticketCount={system.get('ticketCount')}
                    systemStake={system.get('systemStake')}
                />
            ))}
        </div>
    );
}

export default SystemListNg;
